import React, { useCallback, useEffect, useRef, useState } from 'react';
import styles from './switcher.module.scss';
import cx from 'classnames';

type Props = {
  className?: string;
  switched: boolean;
  onSwitch: () => void;
  disabled?: boolean;
  arialabel?: string;
  tabIndex?: number;
};

export const Switcher = (props: Props) => {
  const { className, switched, onSwitch, disabled, tabIndex, arialabel } = props;

  const [focused, setFocuset] = useState<boolean>(false);

  const handleSwitch = () => {
    if (!disabled) {
      onSwitch();
    }
  };

  const classNames = cx(
    styles.switcher,
    { [styles.focused]: focused, [styles.switched]: switched, [styles.disabled]: disabled },
    className
  );

  return (
    <div className={styles.switcherContainer}>
      <div className={classNames} onClick={handleSwitch}>
        <div className={`${styles.handle} `} />
      </div>

      <input
        type="checkbox"
        aria-label={arialabel}
        role="checkbox"
        tabIndex={tabIndex}
        disabled={disabled}
        onClick={onSwitch}
        defaultChecked={switched}
        onFocus={() => setFocuset(true)}
        onBlur={() => setFocuset(false)}
      />
    </div>
  );
};
